module.exports = __webpack_public_path__ + "img/printer-icon-modal.2b70e2ef.svg";